import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as actions from 'actions/index';
import { closeModalPlacedOrderOnCart } from 'actions/Cart';
import GuestRecipientSheet from './GuestRecipientSheet';
import GuestOrdersResult from './GuestOrdersResult';

// Mounted once in the menu: the "Who's this for?" sheet every Add to basket goes
// through when guest ordering is on, and the result of sending one order per person.
const GuestRecipient = props => (
  <div>
    {props.prompt && props.policy ? (
      <GuestRecipientSheet
        policy={props.policy}
        guests={props.guests}
        lastRecipientId={props.lastRecipientId}
        subtitle={props.prompt.subtitle}
        onAdd={props.onChoose}
        onCancel={props.onCancel}
      />
    ) : null}
    {props.batchResult ? (
      <GuestOrdersResult
        result={props.batchResult}
        onClose={() =>
          props.batchResult.allPlaced
            ? props.onAllPlacedClose(props.history)
            : props.onCloseResult()
        }
      />
    ) : null}
  </div>
);

const mapStateToProps = state => ({
  prompt: state.cartReducer.cart.guestPrompt,
  policy: state.cartReducer.cart.guestPolicy,
  guests: state.cartReducer.cart.guests || [],
  lastRecipientId: state.cartReducer.cart.lastRecipientId,
  batchResult: state.cartReducer.cart.batchResult,
});

const mapDispatchToProps = dispatch => ({
  onChoose: choice => dispatch(actions.chooseGuestRecipient(choice)),
  onCancel: () => dispatch(actions.cancelGuestRecipient()),
  onCloseResult: () => dispatch(actions.closeBatchResult()),
  // Everything placed: the basket is cleared, as after any placed order.
  onAllPlacedClose: history => dispatch(closeModalPlacedOrderOnCart(history)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GuestRecipient));



// WEBPACK FOOTER //
// ./src/containers/Menu/Cart/GuestRecipient/index.js